import { DEMO_CALCULATOR_STEP } from 'config/constants'
import { Dispatch, SetStateAction, useEffect } from 'react'

import { isDemoPage } from '../../../../../utils/hooks'
import { useDemoStepPlaybackComplete } from '../../playback-hooks'

type UseDemoCertificationActionParams = {
  disabled?: boolean
  isAllowed?: boolean
}

export const useDemoCertificationAction = ({
  disabled = false,
  isAllowed = false,
}: UseDemoCertificationActionParams = {}) => {
  const isDemoMode = isDemoPage()

  return {
    buttonProps: {
      'data-demo-allowed': isDemoMode && isAllowed ? 'save-certification' : undefined,
      'data-demo-playback-action': isDemoMode ? 'save-certification' : undefined,
    },
    disabled: isDemoMode ? false : disabled,
    isDemoMode,
  }
}

export const useDemoCertificationCompletion = (
  setManualExpanded: Dispatch<SetStateAction<boolean>>,
  setAutoExpanded: Dispatch<SetStateAction<boolean>>,
) => {
  const isDemoMode = isDemoPage()
  const isPlaybackComplete = useDemoStepPlaybackComplete(DEMO_CALCULATOR_STEP.CERTIFICATION)

  useEffect(() => {
    if (!isDemoMode || !isPlaybackComplete) {
      return
    }

    setManualExpanded(false)
    setAutoExpanded(false)
  }, [ isDemoMode, isPlaybackComplete, setAutoExpanded, setManualExpanded ])
}
